import styled from "@emotion/styled";

const SectionWrapper = styled.div`
  min-height: calc(100vh - 100px);

  /* background-color: ${(props) =>
    props.bgColor ? props.bgColor : "#000000"}; */
  /* padding: ${(props) => (props.p ? props.p : "1.5rem 0")}; */
  margin: ${(props) => (props.m ? props.m : "0")};
  @media screen and (max-width: 599px) {
    min-height: calc(100vh - 165px);
  }
`;
const P = styled.p`
  font-family: "Lucida-Regular";
  font-size: ${(props) => (props.fs ? props.fs : "16px")};
  color: ${(props) => (props.color ? props.color : "#fff")};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "100%")};
  text-align: ${(props) => (props.align ? props.align : "left")};
  padding: ${(props) => (props.m ? props.m : "20px 0")};
  margin: 0;
  @media (max-width: 1100px) {
    font-size: 14px;
    max-width: 100%;
  }
  @media (max-width: 1440px) and (max-height: 620px) {
    padding-top: ${(props) => (props.pt630 ? props.pt630 : "0px")};
  }
`;
const CustomContainer = styled.div`
  max-width: 2600px;
`;
const SectionHeading = styled.h2`
  color: #fff;
  font-size: 40px;
  font-family: "Lucida-Regular";
  /* line-height: 80px; */
  margin-top: ${(props) => (props.m ? props.m : "")};
  @media (max-width: 899px) {
    font-size: 50px;
  }
  @media (max-width: 599px) {
    padding: ${(props) => (props.P599 ? props.p599 : "0px 0")};
    line-height: unset;
    font-size: 40px;
  }
`;
const SectionSubHeading = styled.h3`
  font-family: "Lucida-Regular";
  font-size: ${(props) => (props.fs ? props.fs : "25px")};
  text-transform: ${(props) => (props.tt ? props.tt : "uppercase")};
  font-weight: 100;
  color: ${(props) => (props.color ? props.color : "#fff")};
  margin: 0;
  /* margin: 0; */
  padding: ${(props) => (props.p ? props.p : "0")};
  line-height: ${(props) => (props.lh ? props.lh : "")};
  max-width: ${(props) => (props.mw ? props.mw : "100%")};
  text-align: ${(props) => (props.align ? props.align : "left")};

  /* @media (max-width: 599px) {
    padding: ${(props) => (props.p599 ? props.p599 : "40px 0")};
    line-height: ${(props) => (props.lh ? props.lh : "")};
    max-width: 100%;
    font-size: ${(props) => (props.fs599 ? props.fs599 : "35px")};
  } */
`;
const SectionSmallHeading = styled.h3`
  font-family: "Lucida-Regular";
  font-size: ${(props) => (props.fs ? props.fs : "25px")};
  /* text-transform: ${(props) => (props.tt ? props.tt : "uppercase")}; */

  color: ${(props) => (props.color ? props.color : "#fff")};
  padding: ${(props) => (props.p ? props.p : "40px 0")};
  margin: 0;
  line-height: ${(props) => (props.lh ? props.lh : "")};
  max-width: ${(props) => (props.mw ? props.mw : "100%")};
  text-align: ${(props) => (props.align ? props.align : "")};

  @media (max-width: 599px) {
    line-height: ${(props) => (props.lh ? props.lh : "")};
    max-width: 100%;
    font-size: ${(props) => (props.fs599 ? props.fs599 : "")};
  }
`;

export {
  SectionWrapper,
  P,
  SectionHeading,
  SectionSubHeading,
  CustomContainer,
  SectionSmallHeading,
};
